/**
 * Path Tracker :)
 * Appends tracking parameters to hyperlinks on the page.
 * @see https://l.beliefnet.com/bn-edu-christian-leaders-prize-pack-signup/
 * @see https://l.beliefnet.com/bn-edu-christian-leaders-prize-pack-results/
 */
define('components/path-tracker',[
    'jquery',
    'logging',
    'utilities',
    'storage'
], function($, logging, utilities, storage) {
    'use strict';
    
    var _ModuleName = "Path Tracker";

    var _config = {
        debug: false,
        storage: {
            regpath: "pttracker-"
        }
    }

    var _data = {
        track1: ""
    }

    /**
     * Init function is run imediatly, so DOM is not necessarily available.
     * This can be used for getting things ready such as config storage and such
     * @param {object} data Configuration object with data parameters passed in
     */
    var init = function(data) 
    {
        // Get the tracker from the session storage
        _data.track1 = storage.getSessionStorage(_config.storage.regpath + "track1");
        //logging.debug("Session Data: " + JSON.stringify(_data), _ModuleName);
    }

    /**
     * Run function on only run after the DOM is ready
     * This can be used for any DOM manipulation code that needs to run
     */
    var run = function() 
    {
        // Only append the tracker if it exists
        if (_data.track1 != null) 
        {
            logging.debug("Appending path trackers", _ModuleName);

            var querystring = 'track1=' + _data.track1;
            logging.debug(querystring, _ModuleName);

            // Loop through each anchor tag and append the query string.
            // If it already has a query string, just append it.
            $('a').each(function() {
                var href = $(this).attr('href');
                if (href) {
                    href += (href.match(/\?/) ? '&' : '?') + querystring;
                    $(this).attr('href', href);
                }
            });
        }
    }
        
    return {
        init: init,
        run: run
    }
});
